import { Dispatch, SetStateAction, useState } from 'react';

import {
  MaterialTypeDefinition,
  materialTypeDefinitions,
  MaterialTypeName,
  MaterialTypeOption,
  materialTypeOrder,
  SearchAssetResult,
} from '../../entity/SearchAsset';

export type SubType = {
  name: string;
  index: number;
  isRecommend: boolean;
  isService: boolean;
  isTempo: boolean;
};

const getSubTypes = (
  materialType: MaterialTypeDefinition,
  materialTypeOption: MaterialTypeOption,
): ReadonlyArray<SubType> => {
  const subTypeNames = (materialType.tempo == null
    ? materialType.searchService
    : materialType.tempo) as ReadonlyArray<string>;

  if (materialTypeOption[materialType.name].enableRecommend) {
    const recommend: SubType = { name: 'Recommend', index: 0, isRecommend: true, isService: false, isTempo: false };
    return [
      recommend,
      ...subTypeNames.map<SubType>((name, i) => ({
        name,
        index: i + 1,
        isRecommend: false,
        isService: materialType.name !== 'audio',
        isTempo: materialType.name === 'audio',
      })),
    ];
  } else {
    return subTypeNames.map((name, i) => ({
      name,
      index: i,
      isRecommend: false,
      isService: materialType.name !== 'audio',
      isTempo: materialType.name === 'audio',
    }));
  }
};

export const useTypeAndSubType = ({
  defaultType,
  materialTypeOption,
  setSelectedSearchAsset,
}: {
  defaultType: MaterialTypeName;
  materialTypeOption: MaterialTypeOption;
  setSelectedSearchAsset: Dispatch<SetStateAction<SearchAssetResult[number] | null>>;
}) => {
  const [materialType, setMaterialType] = useState<MaterialTypeDefinition>(materialTypeDefinitions[defaultType]);
  const [subTypes, setSubTypes] = useState(getSubTypes(materialType, materialTypeOption));
  const [subType, setSubType] = useState(subTypes[0]);

  const handleMaterialTypeChange = (newMaterialTypeIndex: number) => {
    const nextMaterialType = materialTypeDefinitions[materialTypeOrder[newMaterialTypeIndex]];
    const nextSubTypes = getSubTypes(nextMaterialType, materialTypeOption);
    setSelectedSearchAsset(null);

    setMaterialType(nextMaterialType);
    setSubTypes(nextSubTypes);
    setSubType(nextSubTypes[0]);
  };
  const handleSubTypeChange = (newSubTypeIndex: number) => {
    setSelectedSearchAsset(null);
    setSubType(subTypes[newSubTypeIndex]);
  };

  return [
    { materialType, subType, subTypes },
    { handleMaterialTypeChange, handleSubTypeChange },
  ] as const;
};
